import { WidgetsReportsMain } from '@/widgets/reports';

export const PagesReportsProverkaMain = () => <WidgetsReportsMain type="PROVERKA" />;
